var exports = {
  "gj": "ErrorPageTemplate__H8lmlb",
  "mc": "Container__AYT708",
  "su": "StatusCode__YADHmT",
  "hE": "Title__4hZcih",
  "VY": "Description__dVdxRf",
  "En": "Actions__bbyVgu",
};

module.exports = exports;
